import Store from './views/Store.vue'
import PaymentStatus from './views/PaymentStatus'
import Import from './views/Import'

const route = [
  {
    path: '/',
    name: 'store',
    component: Store,
    meta: {
      layout: 'default',
      auth: true,
      role: ['A','R','C','I']
    }
  },
  {
    path: '/paiement-accepte',
    name: 'store',
    component: PaymentStatus,
    meta: {
      layout: 'default',
      auth: true,
      role: ['A','R','C','I'],
      payment_status: 'accept'
    }
  },
  {
    path: '/paiement-refuse',
    name: 'store',
    component: PaymentStatus,
    meta: {
      layout: 'default',
      auth: true,
      role: ['A','R','C','I'],
      payment_status: 'denied'
    }
  },
  {
    path: '/import',
    name: 'import',
    component: Import,
    meta: {
      layout: 'default',
      auth: true,
      role: ['A', 'R', 'I', 'C'],
    }
  },
]

export default route